import * as Loading from './loading.json'
import * as Check from './check.json'

export default {
    loading: Loading.default,
    check: Check.default
}